export default __webpack_public_path__ + "static/media/tock-logo.1c100cbf.png";